import React from 'react'
import { useNavigate } from 'react-router-dom'

// Maps InterviewDataSection activityType values to ActivityMetricDetailsPage metric types
const ACTIVITY_TYPE_TO_METRIC = {
    'interview_schedule':       'interview-scheduled',
    'walkins':                  'scheduled-attended',
    'interview_not_attended':   'interview-not-attended',
    'screening':                'screening-calls',
    'Internal_Hiring':          'internal-hiring',
    'On_Hold':                  'total-activities',
    'Reject':                   'final-rejected-by-us',
    'Rejected_by_Candidate':    'final-rejected-by-candidate',
    'consider_to_client':       'successful-outcomes',
    'Offers':                   'final-offered',
    'Offer_did_not_accept':     'final-not-joined',
    'walkout':                  'walkout',
};

const getLastDay = (year, month) => new Date(year, month + 1, 0).getDate();

const TableRow = ({ dates, loginEmpId, targetEmpId, month, year, label, activityType, interviewData, objField }) => {
    let navigate = useNavigate()

    const metricType = ACTIVITY_TYPE_TO_METRIC[activityType] || 'total-activities';
    const targetParam = targetEmpId ? `&target_emp_id=${targetEmpId}` : '';

    const navigateToDetails = (date) => {
        if (date) {
            navigate(`/activity/details/${metricType}?filter_type=custom&start_date=${date}&end_date=${date}${targetParam}`);
        } else {
            const paddedMonth = String(month + 1).padStart(2, '0');
            const lastDay = String(getLastDay(year, month)).padStart(2, '0');
            navigate(`/activity/details/${metricType}?filter_type=custom&start_date=${year}-${paddedMonth}-01&end_date=${year}-${paddedMonth}-${lastDay}${targetParam}`);
        }
    };

    return (
        <tr>
            <td onClick={() => navigateToDetails(null)}
                style={{ minWidth: '250px' }} className='sticky-left cursor-pointer hover:bg-slate-50'>
                <p className='text-blue-600 mb-0 p-0'>{label}</p>
            </td>
            <td className='sticky left-[260px] bg-white'>
                {interviewData && interviewData[activityType].reduce((acc, obj) => {
                    let num = obj[objField]?.length || 0
                    return acc + num
                }, 0)}
            </td>
            {dates && dates.map((date) => {
                let findVal = interviewData[activityType].find((obj) => obj.date == date)
                return (
                    <td key={date} onClick={() => {
                        if (findVal && findVal[objField].length > 0)
                            navigateToDetails(date)
                    }} className={`${findVal && findVal[objField].length > 0 ? 'cursor-pointer hover:bg-slate-50' : ''}`}>
                        <span className={`${findVal && findVal[objField].length > 0 ? 'text-blue-600' : ''}`}>
                            {findVal ? findVal[objField].length : '--'}
                        </span>
                    </td>
                )
            })}
        </tr>
    )
}

export default TableRow